let hoverList, listItemArr, copyArr, imageContainerArr;

const changeImage = e => {
    const clickedId = e.target.getAttribute('data-post-id');
    imageContainerArr.map(container => {
        const imageId = container.getAttribute('data-post-id');
        if (imageId === clickedId) {
            container.classList.add('hover-carousel__image-container--selected');
        } else {
            container.classList.remove('hover-carousel__image-container--selected');
        }
    });
    listItemArr.map(item => {
        const itemId = item.getAttribute('data-post-id');
        if (itemId === clickedId) {
            item.classList.add('hover-carousel__list-item--selected');
        } else {
            item.classList.remove('hover-carousel__list-item--selected');
        }
    });
    copyArr.map(copy => {
        const copyId = copy.getAttribute('data-post-id');
        if (copyId === clickedId) {
            copy.classList.add('hover-carousel__copy--selected');
        } else {
            copy.classList.remove('hover-carousel__copy--selected');
        }
    });
};

export const addHoverListeners = () => {
    const hoverGrid = document.querySelector('.hover-carousel__grid');
    if (hoverGrid) {
        hoverList = document.querySelector('.hover-carousel__list');
        hoverList.addEventListener('click', changeImage);
        const imageContainers = document.querySelectorAll('.hover-carousel__image-container');
        imageContainerArr = Array.from(imageContainers);
        const listItems = document.querySelectorAll('.hover-carousel__list-item');
        listItemArr = Array.from(listItems);
        const copy = document.querySelectorAll('.hover-carousel__copy');
        copyArr = Array.from(copy);
    }
};

export const removeHoverListeners = () => {
    const hoverGrid = document.querySelector('.hover-carousel__grid');
    if (hoverGrid && hoverList) {
        hoverList.removeEventListener('click', changeImage);
    }
};

addHoverListeners();
